module.exports = __webpack_public_path__ + "static/media/Features 1.1a4abb81.svg";